import { render, staticRenderFns } from "./SectionWidthForm.vue?vue&type=template&id=6690797e"
import script from "./SectionWidthForm.vue?vue&type=script&lang=js"
export * from "./SectionWidthForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports